/* eslint-disable */

export const getOneScheduledOrderConstants = {
    GET_ONE_SCHEDULED_ORDER_REQUEST: 'GET_ONE_SCHEDULED_ORDER_REQUEST',
    GET_ONE_SCHEDULED_ORDER_SUCCESS: 'GET_ONE_SCHEDULED_ORDER_SUCCESS',
    GET_ONE_SCHEDULED_ORDER_FAILURE: 'GET_ONE_SCHEDULED_ORDER_FAILURE',
};
